// src/store/reducers/businessCase.reducer.js
const initialState = {
  inputs: {
    claims: 1000,
    repairablePct: 50,
    rrp: 100
  },
  loading: false,
  error: null,
  previous: null, // previous API response
  current: null // latest API response
};

export default function businessCaseReducer(state = initialState, action) {
  switch (action.type) {
    case 'SET_BUSINESS_CASE_INPUTS':
      return { ...state, inputs: { ...state.inputs, ...action.payload } };

    case 'SET_BUSINESS_CASE_LOADING':
      return { ...state, loading: action.payload };

    case 'SET_BUSINESS_CASE_ERROR':
      return { ...state, error: action.payload };

    case 'SET_BUSINESS_CASE_RESULT': {
      const { previous, current } = action.payload || {};
      return {
        ...state,
        previous,
        current,
        loading: false,
        error: null
      };
    }

    default:
      return state;
  }
}
